interface SearchResultsHeadingProps {
  searchTerm: string;
  loading: boolean;
  resultsLength: number;
}

const SearchResultsHeading = (props: SearchResultsHeadingProps) => {
  const { searchTerm, loading, resultsLength } = props;
  if (loading || !searchTerm) {
    return null;
  }

  return (
    <p className="py-2 font-bold">
      {`${resultsLength} results for `}
      <span className="text-blue-500 italic">{searchTerm}</span>
    </p>
  );
};

export default SearchResultsHeading;
